export const getMemberCustomerIdOrEmail = ({ customerId, email }) => {
	if (customerId) {
		return {
			customer_id: customerId
		};
	}

	return {
		email
	};
};
